export default __webpack_public_path__ + "static/media/video-image.361d289b.svg";